import { type Dispatch, type SetStateAction, useRef } from 'react'

import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'
import styled from 'styled-components'

interface IProps {
    count: number
    setCount: Dispatch<SetStateAction<number>>
    startFetching: () => void
}

export const PostNotifier = ({ count, setCount, startFetching }: IProps) => {
    const queryClient = useQueryClient()
    const fetchingRef = useRef<boolean>(false)
    const { t } = useTranslation()

    const fetchNewPosts = async () => {
        if (fetchingRef.current) {
            return
        }
        fetchingRef.current = true
        startFetching()
        setCount(0)

        queryClient.removeQueries({
            queryKey: ['getHomeFeed']
        })

        fetchingRef.current = false
    }

    return (
        <Wrapper onClick={fetchNewPosts}>
            {count} {t('newPosts')}
        </Wrapper>
    )
}

const Wrapper = styled.div`
    position: fixed;
    top: 7.5rem;
    left: 50%;
    transform: translate(-50%, 0);

    z-index: 99;

    background: rgba(235, 235, 235, 70%);
    padding: 1rem;
    border-radius: 2rem;
    cursor: pointer;
    color: #0d1444;

    font-size: 12px;
    font-weight: 600;
    line-height: 14.63px;
    letter-spacing: 0.04em;
    text-align: left;
`
